<mat-form-field>
    <mat-label>{{ label }}</mat-label>
    <input matInput #searchInput [(ngModel)]="value" [placeholder]="placeholder" (input)="hydrateValue()" >
</mat-form-field>
